module.exports = __webpack_public_path__ + "static/media/GA_Post_2018.12.16.7e95fe09.webp";